import { FC } from 'react';
import { ContentOutdatedVariable } from '../ProcessVariableCard.styles';
import { AllieText } from '../../../../components';
import { AlliePresentationChartIcon } from '../../../../styling/icons';

interface ContentOutdatedProps {
  text: string;
  title: string;
}

export const ContentOutdated: FC<ContentOutdatedProps> = ({ text, title }) => {
  return (
    <ContentOutdatedVariable>
      <AlliePresentationChartIcon className="presentation-chart-icon" />
      <AllieText color="neutral-90" type="body2" weight={600}>
        {title}
      </AllieText>
      <AllieText
        className="text-outdated"
        color="neutral-80"
        type="body2"
      >
        {text}
      </AllieText>
    </ContentOutdatedVariable>
  );
};
